import React from 'react';
import { toast } from 'react-toastify';

export const info = (content: string | JSX.Element | React.FC): void => {
  toast(content, {
    type: 'info',
  });
};
export default info;
